import { isEditing } from "../common/common"
import { setterAction } from "../common/redux"
import tracker from "../common/tracker"
import { captureException } from "../common/error"
import * as t from "./actionTypes"
import * as interviewActions from "../interview/actions"
import * as generator from "../chatItemGenerator"
import Source from "../interview/Source"
import { SOMETHING_ELSE, UNSURE, SPECIALIST } from "./constants"
import { messages } from "../chatItemGenerator"

export const setFlaggedQuestion = setterAction(t.SET_FLAGGED_QUESTION)
export const setUnflaggedQuestion = setterAction(t.SET_UNFLAGGED_QUESTION)
export const setQuestionComplaint = setterAction(t.SET_QUESTION_COMPLAINT)
export const setFlag = setterAction(t.SET_FLAG)
const _setFlagFeedback = setterAction(t.SET_FLAG_FEEDBACK)
export const setExplanation = setterAction(t.SET_EXPLANATION)
export const flagItem = setterAction(t.FLAG_ITEM)
export const unflagItem = setterAction(t.UNFLAG_ITEM)
export const setVisitFeedbackOpen = setterAction(t.SET_VISIT_FEEDBACK_OPEN)
export const setDiagnosisTag = setterAction(t.SET_DIAGNOSIS_TAG)
export const setDoctorTag = setterAction(t.SET_DOCTOR_TAG)
export const setCustomSubmitted = setterAction(t.SET_CUSTOM_SUBMITTED)
export const setCustomTag = setterAction(t.SET_CUSTOM_TAG)
export const setDiagnosisQuery = setterAction(t.SET_DIAGNOSIS_QUERY)
export const setDiagnosisSuggestions = setterAction(t.SET_DIAGNOSIS_SUGGESTIONS)
export const incrementDiagnosisSuggestions = setterAction(
  t.INCREMENT_DIAGNOSIS_SUGGESTION
)
export const decrementDiagnosisSuggestions = setterAction(
  t.DECREMENT_DIAGNOSIS_SUGGESTION
)
export const setTaggingFinished = setterAction(t.SET_TAGGING_FINISHED)
export const setFollowUpOptions = setterAction(t.SET_FOLLOW_UP_OPTIONS)
export const setFollowUpResponse = setterAction(t.SET_FOLLOW_UP_RESPONSE)
export const setFollowUpText = setterAction(t.SET_FOLLOW_UP_TEXT)
export const setFollowUpSubmitted = setterAction(t.SET_FOLLOW_UP_SUBMITTED)
export const showNpsCard = setterAction(t.SET_SHOW_NPS_CARD)
export const setNpsSubmitted = setterAction(t.SET_NPS_SUBMITTED)
export const setGetNpsFeedback = setterAction(t.SET_GET_NPS_FEEDBACK)
export const setSpecialistSuggestion = setterAction(t.SET_SPECIALIST_SUGGESTION)
export const setDiagnosisConcern = setterAction(t.SET_DIAGNOSIS_CONCERN)

export const showPostIntentPopUp = show => (dispatch, getState) => {
  const { showFollowUpModal } = getState().completion
  const followUp = showFollowUpModal.shown
  if (!followUp) {
    dispatch({ type: t.SET_SHOW_POST_INTENT_POPUP, payload: show })
  }
}

export const setFeedback = (question, options) => (dispatch, getState) => {
  let { flaggedQuestion } = getState().feedback
  if (flaggedQuestion) {
    return dispatch(setFlagFeedback(question, options))
  } else if (question.inputType === "end") {
    dispatch(
      interviewActions.addChatItem(generator.systemMessage(question.text))
    )
  } else {
    if (options.length === 1 && question.inputType !== "freetext") {
      dispatch(
        submitFeedback({
          text: options[0].text,
          token: options[0].token,
          qtext: question.text,
          category: "P",
        })
      )
    } else if (options.length === 0) {
      dispatch(
        submitFeedback({
          text: "",
          token: "",
          qtext: question.text,
          category: "P",
        })
      )
    } else {
      let option_objects = options.map(o => ({
        text: o.text,
        token: o.text,
        qtext: question.text,
      }))
      dispatch(
        interviewActions.addChatItem(
          generator.feedback(
            question.text,
            question.inputType !== "differential"
              ? question.inputType
              : "radio",
            option_objects
          )
        )
      )
    }
  }
}

export const setFlagFeedback = (question, options) => dispatch => {
  if (question.inputType === "end") {
    dispatch(_setFlagFeedback(null))
    return
  }

  let option_objects = options.map(o => ({
    text: o.text,
    token: o.text,
    qtext: question.text,
  }))
  dispatch(
    _setFlagFeedback({
      text: question.text,
      options: option_objects,
    })
  )
}

export const feedbackClick = option => (dispatch, getState) => {
  let { items, active } = getState().chatList
  if (isEditing(items, active)) {
    dispatch(interviewActions.deleteChatItems())
  }
  dispatch(interviewActions.addChatItem(generator.response(option.text, true)))
  option.category = "P"
  dispatch(submitFeedback(option))
}

export const submitFlagFeedback = feedback => (dispatch, getState) => {
  let item = getState().feedback.flaggedQuestion
  dispatch(flagItem(item))
  Source.questionFeedback(item.token, feedback)
  tracker.flagItem()
}

export const submitFeedback = option => dispatch => {
  Source.submitFeedback(option)
    .then(({ question, options }) => dispatch(setFeedback(question, options)))
    .catch(error => dispatch(interviewActions.genericError(error)))
}

export const setComplaint = item => (dispatch, getState) => {
  tracker.thisIsConfusing()
  let { chatList } = getState()
  Source.questionFeedback(item.token)
  if (!item) {
    item = chatList.items[chatList.active]
  }

  dispatch(setFlaggedQuestion(item))
  dispatch(setFlag({ flag: true }))
}

export const cancelFlag = () => (dispatch, getState) => {
  let { flaggedQuestion, unflaggedQuestion } = getState().feedback
  if (flaggedQuestion) {
    dispatch(setFlaggedQuestion(null))
  }

  if (unflaggedQuestion) {
    dispatch(setUnflaggedQuestion(null))
  }
}

export const toggleQuestionFlag = () => (dispatch, getState) => {
  let { flaggedQuestion, unflaggedQuestion } = getState().feedback
  let item = flaggedQuestion || unflaggedQuestion
  item.flagged = !item.flagged
  if (!item.complaint) item.complaint = ""

  dispatch(setFlaggedQuestion(null))
  dispatch(setUnflaggedQuestion(null))
}

export const getExplanation = () => (dispatch, getState) => {
  let { chatList } = getState()
  let activeItem = chatList.items[chatList.active]
  tracker.explainClick()
  if (activeItem.type === "sex") {
    dispatch(
      setExplanation({
        heading: messages.identifiersSexWhy,
        text: messages.identifiersSexWhyBody,
      })
    )
  } else if (activeItem.type === "age") {
    dispatch(
      setExplanation({
        heading: messages.identifiersAgeWhy,
        text: messages.identifiersAgeWhyBody,
      })
    )
  } else if (activeItem.type === "insuranceCapture") {
    dispatch(
      setExplanation({
        heading: "Know your options",
        text:
          "If you do need care, your insurance information may help me suggest providers in your network.",
      })
    )
  } else if (activeItem.type === "employerCaptureIntro") {
    dispatch(
      setExplanation({
        heading: "See what makes sense",
        text:
          "Certain employers partner with Buoy so that, if care is needed, I can find covered providers.",
      })
    )
  } else if (activeItem.type === "employerCaptureInput") {
    dispatch(
      setExplanation({
        heading: "Get personalized next steps",
        text:
          "I'll only use the employer's name to check if they partner with Buoy. If they do, I may be able to suggest covered care providers.",
      })
    )
  } else {
    Source.getQuestionExplanation(activeItem.token)
      .then(data => {
        dispatch(setExplanation(data))
      })
      .catch(error => dispatch(interviewActions.genericError(error)))
  }
}

export const finishTagging = () => (dispatch, getState) => {
  let { feedback, completion } = getState()
  let { doctor, diagnosis, custom, finished } = feedback.tagging

  if (finished) return

  if (doctor && typeof diagnosis === "number") {
    Source.submitVisitTruth({
      token: completion.token || completion.results.token,
      differential: completion.results.differential[diagnosis].token,
      doctor,
    })
  } else if (doctor && (custom.diagnosis || custom.query)) {
    Source.submitVisitTruth({
      token: completion.token || completion.results.token,
      custom: custom.diagnosis || custom.query,
      doctor,
    })
  }

  tracker.userTaggingSubmitted()
  dispatch(setTaggingFinished(true))
}

export const getFollowUpOptions = () => dispatch => {
  Source.userIntentCareOptions(true)
    .then(data => {
      const options = data.options.map(option => {
        return {
          text: option.display,
          token: option.option,
        }
      })
      dispatch(setFollowUpOptions(options))
    })
    .catch(captureException)
}

export const submitFollowUp = response => dispatch => {
  dispatch(setFollowUpResponse(response))

  switch (response) {
    case "":
    case SOMETHING_ELSE:
    case UNSURE:
    case SPECIALIST:
      return null
    default:
      Source.submitUserIntent(true, response, "", true)
        .then(() => {
          tracker.followUpAnswered()
          dispatch(setFollowUpSubmitted(true))
          setTimeout(() => {
            dispatch(showPostIntentPopUp(false))
          }, 2000)
        })
        .catch(captureException)
  }
}

export const submitFollowUpText = () => (dispatch, getState) => {
  let { text, response } = getState().feedback.followUp
  Source.submitUserIntent(true, response, "", true, text)
    .then(() => {
      tracker.followUpAnswered()
      dispatch(setFollowUpSubmitted(true))
      setTimeout(() => {
        dispatch(showPostIntentPopUp(false))
      }, 2000)
    })
    .catch(captureException)
}

export const submitNpsFeedback = (score, comment) => dispatch => {
  tracker.npsComplete()
  Source.submitNps(score, comment)
    .then(data => {
      dispatch({ type: t.SUBMIT_NPS_COMMENT, payload: comment })
      dispatch({ type: t.SUBMIT_NPS_SCORE, payload: score })
      dispatch(setNpsSubmitted(true))
    })
    .catch(captureException)
}

export const submitNpsScore = score => dispatch => {
  tracker.npsResponseGiven()
  if (score >= 9) {
    tracker.npsPromoters()
  } else if (score >= 7) {
    tracker.npsPassives()
  } else {
    tracker.npsDetractors()
  }

  Source.submitNps(score, null)
    .then(data => {
      dispatch({ type: t.SUBMIT_NPS_SCORE, payload: score })
    })
    .catch(captureException)
}

export const diagnosisSearchChange = (text, position) => (
  dispatch,
  getState
) => {
  dispatch(setDiagnosisQuery(text))
  dispatch(setDiagnosisSuggestions([]))
  dispatch(setCustomTag(""))
  if (text.length >= 3) {
    clearTimeout(window.searchTimer)
    window.searchTimer = setTimeout(
      () => {
        dispatch(executeDiagnosisSearch(position))
      },
      window.searchTime ? window.searchTime : 500
    )
  } else {
    dispatch(
      setDiagnosisSuggestions([{ text, token: "PLACEHOLDER", index: 0 }])
    )
  }
}

export const executeDiagnosisSearch = position => (dispatch, getState) => {
  let { tagging } = getState().feedback
  let { query } = tagging.custom
  if (!query || !query.length) return

  Source.diagnosisSearch(query, position)
    .then(data => {
      window.diagSearchRetrys = 0
      if (data.interpretations) {
        dispatch(
          setDiagnosisSuggestions(
            data.interpretations.map((s, i) => {
              return {
                index: i,
                text: typeof s === "string" ? s : s.join(", "),
                token: s,
              }
            })
          )
        )
      } else {
        dispatch(setDiagnosisSuggestions([]))
      }
    })
    .catch(error => {
      dispatch(setDiagnosisSuggestions([]))
      if (!window.searchRetrys) window.searchRetrys = 0

      if (window.searchRetrys < 3) {
        window.searchTimer = setTimeout(() => {
          window.searchRetrys += 1
          dispatch(executeDiagnosisSearch(position))
        }, 1000)
      }
    })
}

export const selectActiveSuggestion = () => (dispatch, getState) => {
  let { tagging } = getState().feedback
  let { suggestions } = tagging.custom
  dispatch(suggestionClick(suggestions.active))
}

export const suggestionClick = index => (dispatch, getState) => {
  let { tagging } = getState().feedback
  let { suggestions } = tagging.custom
  if (index < suggestions.items.length) {
    dispatch(setCustomTag(suggestions.items[index].text))
    dispatch(setDiagnosisQuery(""))
    dispatch(setDiagnosisSuggestions([]))
  }
}



// WEBPACK FOOTER //
// ./assets/feedback/actions.js